import Badge from "@mui/material/Badge";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MDBox from "../components/MDBox";
import { useEffect, useRef, useState } from "react";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import GppGoodIcon from "@mui/icons-material/GppGood";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import {
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import colors from "../assets/theme/base/colors";
import GeneralDialog from "../components/Dialog";
import CircleIcon from "@mui/icons-material/Circle";
import MDTypography from "../components/MDTypography";
import AppChipLabel from "../components/AppIconButton/ApplicationChipLabel";
const NotificationBadges = (props) => {
  const [openDialog, setOpenDialog] = useState(false);

  function notificationsLabel(count) {
    if (count === 0) {
      return "no notifications";
    }
    if (count > 99) {
      return "more than 99 notifications";
    }
    return `${count} notifications`;
  }

  const {
    actorBadgeContent,
    notificationBadgeContent,
    listOfRoles,
    user_name,
  } = props;

  const renderRoleList = () => {
    return (
      <List dense={false}>
        {listOfRoles.map((role) => {
          return (
            <ListItem key={role.name}>
              <ListItemIcon>
                <GppGoodIcon
                  fontSize="large"
                  sx={({ breakpoints }) => ({
                    color: colors.JTCElectricBlue,
                    [breakpoints.down("md")]: {
                      fontSize: "medium",
                    },
                  })}
                />
              </ListItemIcon>
              <ListItemText>
                <MDBox pr={1} ml={-1} mt={-0.1}>
                  <MDTypography
                    variant="button"
                    fontSize="1rem"
                    fontWeight="bold"
                    color="dark"
                    sx={{ textOverflow: "hidden" }}
                  >
                    {role.name}
                  </MDTypography>
                </MDBox>
              </ListItemText>
              {<AppChipLabel appCode={role.app_code} />}
            </ListItem>
          );
        })}
      </List>
    );
  };

  return (
    <MDBox
      borderRadius="xl"
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      pt={4}
      pb={2}
      pr={1}
      sx={{
        opacity: "100%",
      }}
    >
      <Stack direction={"row"} spacing={1} sx={{ paddingRight: 1 }}>
        <MDTypography
          sx={({ breakpoints }) => ({
            // minHeight: "6vh",
            display: { xs: "none", md: "flex" },
            fontFamily: "Barlow",
            color: colors.JTC.jtcblue2,
            fontWeight: "bold",
            overflow: "hidden",
            fontSize: "1.2rem",
            textOverflow: "ellipsis",
            [breakpoints.down("md")]: {
              fontSize: "medium",
              fontWeight: "bold",
            },
          })}
        >
          Welcome,
        </MDTypography>
        <MDTypography
          sx={({ breakpoints }) => ({
            // minHeight: "6vh",
            fontFamily: "Barlow",
            color: colors.JTC.jtcblue2,
            fontWeight: "900",
            overflow: "hidden",
            fontSize: "1.2rem",
            textOverflow: "ellipsis",
            [breakpoints.down("md")]: {
              fontSize: "medium",
              fontWeight: "bold",
            },
          })}
        >
          {" " + user_name}
        </MDTypography>
      </Stack>

      <MDBox display="flex" flexDirection="row">
        <IconButton
          aria-label={notificationsLabel(actorBadgeContent)}
          onClick={() => {
            setOpenDialog(true);
          }}
        >
          <Badge badgeContent={actorBadgeContent} color="secondary">
            <RecentActorsIcon sx={{ color: colors.JTCElectricBlue }} />
          </Badge>
        </IconButton>
        {/* Bell Icon...
        <IconButton aria-label={notificationsLabel(notificationBadgeContent)}>
          <Badge badgeContent={notificationBadgeContent} color="secondary">
            <NotificationsIcon sx={{ color: colors.JTCElectricBlue }} />
          </Badge>
        </IconButton> */}
      </MDBox>
      <GeneralDialog
        open={openDialog}
        title={"User-Identity"}
        type={"none"}
        messageLine1={""}
        messageLine1Node={renderRoleList()}
        goText={"Ok"}
        hideCancel={true}
        setOpenDialog={setOpenDialog}
      />
    </MDBox>
  );
};
NotificationBadges.propTypes = {
  actorBadgeContent: PropTypes.number,
  notificationBadgeContent: PropTypes.number,
};
NotificationBadges.defaultProps = {
  actorBadgeContent: 0,
  notificationBadgeContent: 0,
};
export default NotificationBadges;
